import { CCol, CDataTable, CPagination, CRow } from "@coreui/react";
import GeneratedRecord, { formatSerialNumber, GeneratedRecordItem } from "../../models/generated-record";
import { formatUTCDateTime } from "../../utils/dates";
import { defaultValueOnUndefined } from "../../utils/fields";

interface RecordDDetailMainDataProps {
  record?: GeneratedRecord;
  items:GeneratedRecordItem[];
  totalPages:number,
  currentPage:number,
  onPageChange: (page:number) => void | Promise<void>;
  onItemClick: (recordItem:GeneratedRecordItem) => void | Promise<void>;
}

const RecordDetailMainData: React.FC<RecordDDetailMainDataProps> = ({
  record,
  items,
  totalPages,
  currentPage,
  onPageChange,
  onItemClick,
}) => {

  const fields = [
    {
      key: "serialNumber",
      _classes: ["text-right", "align-middle", "custom-header"],
      label: "Item",
    },
    {
      key: "shipment",
      _classes: ["text-right", "align-middle", "custom-header"],
      label: "Partida",
    },
    {
      key: "uvfQuantity",
      _classes: ["text-right", "align-middle", "custom-header"],
      label: "Unid.Físicas",
    },
    {
      key: "commercialUnitQuantity",
      _classes: ["text-right", "align-middle", "custom-header"],
      label: "Unid.Comerciales",
    },
    {
      key: "netWeight",
      _classes: ["text-right", "align-middle", "custom-header"],
      label: "Peso Neto",
      filter: false,
    },
    {
      key: "grossWeight",
      _classes: ["text-right", "align-middle", "custom-header"],
      label: "Peso Bruto",
      filter: false,
    },
    {
      key: "customsValueUsd",
      _classes: ["text-right", "align-middle", "custom-header"],
      label: "Valor Aduanas",
      filter: false,
    },
  ];

  return (
    <>
    <CRow>
      <CCol md={6} sm={12}>
        <CRow><CCol sm={6} md={4}><strong>Fecha de Numeración</strong></CCol><CCol sm={6}>{record?.numberingDate
            ? formatUTCDateTime(
                new Date(record.numberingDate)
              )
            : defaultValueOnUndefined(
                "-",
                record?.numberingDate
              )}</CCol></CRow>
      </CCol>
      <CCol md={6} sm={12}>
        <CRow><CCol sm={6} md={4}><strong>Documento</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("DUA", record?.document)}</CCol></CRow>
      </CCol>
    </CRow>

    <CRow >
      <CCol md={6} sm={12} className={"mt-5"}>
        <CRow><CCol><h3 style={{ color: "#004080" }}>Datos Generales del DUA</h3></CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>Importador</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", record?.importer)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>Total Valor Aduanas ($)</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", record?.totalCustomsValueUsd)}</CCol></CRow>
        <CRow><CCol sm={6} md={4} ><strong>Total Peso Neto</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", record?.totalNetWeight)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>Total Peso Bruto</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", record?.totalGrossWeight)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>Medio de Transporte</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", record?.modeOfTransport)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>Aduana de Ingreso</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", record?.entryCustoms)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>Aduana Destino</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", record?.destinationCustoms)}</CCol></CRow>
      </CCol>
      <CCol md={6} sm={12} className={"mt-5"}>
        <CRow><CCol><h3 style={{ color: "#004080" }}>Tributos</h3></CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>IMADUNI</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", record?.imaduni)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>Recargo Mínimo</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", record?.minimumSurcharge)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>Recargo Móvil</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", record?.mobileSurcharge)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>Recargo Adicional</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", record?.additionalSurcharge)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>IVA</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", record?.vat)}</CCol></CRow>
        <CRow><CCol sm={6} md={4}><strong>IVA Anticipo</strong></CCol><CCol sm={6}>{defaultValueOnUndefined("", record?.vatAdvance)}</CCol></CRow>
      </CCol>
    </CRow>
    {/*<CRow >
      <CCol className={"mt-4"}>
        <CDataTable
          noItemsView={<h2 className="text-center">Sin Resultados</h2>}
          addTableClasses={`table-fixed ${items?.length>0?"hover-style":""}`}
          fields={fields}
          items={items}
          striped
          scopedSlots={{
            serialNumber: (item: GeneratedRecordItem) => {
              return (
                <td className="text-right align-middle">
                  <a href={"#"} onClick={()=>onItemClick(item)}>
                    {formatSerialNumber(item.serialNumber)}
                  </a>
                </td>
              );
            },
            shipment: (item: GeneratedRecordItem) => {
              return (
                <td className="text-right align-middle">
                  {defaultValueOnUndefined("", item?.shipment)}
                </td>
              );
            },
            uvfQuantity: (item: GeneratedRecordItem) => {
              return (
                <td className="text-right align-middle">
                  {defaultValueOnUndefined("", item?.uvfQuantity)}
                </td>
              );
            },
            commercialUnitQuantity: (item: GeneratedRecordItem) => {
              return (
                <td className="text-right align-middle">
                  {defaultValueOnUndefined("", item?.commercialUnitQuantity)}
                </td>
              );
            },
            netWeight: (item: GeneratedRecordItem) => {
              return (
                <td className="text-right align-middle">
                  {defaultValueOnUndefined("", item?.netWeight)}
                </td>
              );
            },
            grossWeight: (item: GeneratedRecordItem) => {
              return (
                <td className="text-right align-middle">
                  {defaultValueOnUndefined("", item?.grossWeight)}
                </td>
              );
            },
            customsValueUsd: (item: GeneratedRecordItem) => {
              return (
                <td className="text-right align-middle">
                  {defaultValueOnUndefined("", item?.customsValueUsd)}
                </td>
              );
            },
          }}
        />
        <div className="d-flex justify-content-center">
          <CPagination
            pages={totalPages}
            activePage={currentPage}
            onActivePageChange={(i: number) => onPageChange(i)}
            className={totalPages < 2 ? "d-none" : ""}
          />
        </div>
      </CCol>
    </CRow>*/}
    <style>{`
        .custom-header {
          background-color: #004080;
          color: white;
        }

        .hover-style tbody tr:hover {
          background-color: #00c0c0;
        }

        .table-field {
          text-align: right;
          vertical-align: middle;
        }
      `}</style>
      
    </>
  );
};

export default RecordDetailMainData;
